<template>
<div>
	这是首页	
</div>
</template>
<script>
export default {
	name: "index",
	 data: () => {
    return {

	}
	},
	mounted(){
	},
	methods: {
	}
}
</script>
<style lang="scss" scoped>
</style>